/**
 * Employee Tax Types IDs
 */
export const EMPLOYEE_TAX_TYPES = {
	Owner: 6,
	CorporateOfficer: 7,
} as const;

/**
 * The return type for the getBannerMessaging function
 */
type GetBannerMessagingReturn = { title: string } | null;

/**
 * Gets the banner messaging for an employee tax type if needed
 * @param selectedEmployeeTaxTypeId the employee tax type
 * @returns messaging if needed for the type
 */
export function getBannerMessaging(
	selectedEmployeeTaxTypeId: string | number,
): GetBannerMessagingReturn {
	const employeeTaxTypeId =
		typeof selectedEmployeeTaxTypeId === 'number'
			? selectedEmployeeTaxTypeId
			: parseInt(selectedEmployeeTaxTypeId);

	switch (employeeTaxTypeId) {
		case EMPLOYEE_TAX_TYPES.Owner:
			return {
				title: $.__(
					'The Owner tax type may be exempt from Federal or State taxes. You can mange it in your Federal and State withholdings.',
				),
			};
		case EMPLOYEE_TAX_TYPES.CorporateOfficer:
			return {
				title: $.__(
					'The Corporate Officer tax type may be exempt from Federal or State taxes. You can mange it in your Federal and State withholdings.',
				),
			};
		default:
			return null;
	}
}
